'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const MessageIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.75195 4.75C2.75195 4.19772 3.19967 3.75 3.75195 3.75H20.252C20.8042 3.75 21.252 4.19771 21.252 4.75V17.25C21.252 17.8023 20.8042 18.25 20.252 18.25H12.002L7.00195 21V18.25H3.75195C3.19967 18.25 2.75195 17.8023 2.75195 17.25V4.75Z",
          stroke: "currentColor",
          strokeLinecap: "square"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.5 12C6.94772 12 6.5 11.5523 6.5 11C6.5 10.4477 6.94772 10 7.5 10C8.05228 10 8.5 10.4477 8.5 11C8.5 11.5523 8.05228 12 7.5 12ZM12 12C11.4477 12 11 11.5523 11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11C13 11.5523 12.5523 12 12 12ZM16.5 12C15.9477 12 15.5 11.5523 15.5 11C15.5 10.4477 15.9477 10 16.5 10C17.0523 10 17.5 10.4477 17.5 11C17.5 11.5523 17.0523 12 16.5 12Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpMessageIcon = forwardRef(MessageIcon);

export { VpMessageIcon as default };
